import { FC } from "react";
import { IconPropsType } from ".";

export const Wallet: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 4.5V4.5C13.5 3.67157 12.8284 3 12 3L3 3C1.89543 3 1 3.89543 1 5L1 11.5C1 12.6046 1.89543 13.5 3 13.5H12C12.8284 13.5 13.5 12.8284 13.5 12V12"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.75 8.25C8.75 7.42157 9.42157 6.75 10.25 6.75H13.75C14.5784 6.75 15.25 7.42157 15.25 8.25C15.25 9.07843 14.5784 9.75 13.75 9.75H10.25C9.42157 9.75 8.75 9.07843 8.75 8.25Z"
        stroke={props.color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
